import React, { useEffect, useRef, useState } from 'react';
import PropTypes from 'prop-types';
import classes from '../../../pipeline.module.scss';
import Api from '../../../../../../../api/api';
import Table from '../../../../../../_common/Tables/Table';
import { Card } from '../../PipelineComponents';
import { formattedCount, formattedDays } from '../../../pipelineHelpers';

const tableHeader = [
  { name: 'Rx', path: 'scriptId' },
  { name: 'Member', path: 'name' },
  { name: 'Medication', path: 'productName' },
  { name: 'Processed', path: 'processedOn' },
  { name: 'Shipped', path: 'shipOn' },
  { name: 'ETA', path: 'eta' },
  { name: 'Delivered', path: 'deliveredOn' },
  { name: 'Processed → shipped', path: 'processToShipDays' },
  { name: 'Shipped → delivered', path: 'shipToDeliveredDays' },
];

const limit = 10;

const ProcessingTimesCard = ({ params }) => {
  const firstLoad = useRef(true);

  const [averages, setAverages] = useState([]);
  const [loading, loadingToggle] = useState(true);

  useEffect(() => {
    (async () => {
      try {
        loadingToggle(true);

        const { data } = await Api.getProcessingTimes({ ...params, limit });

        setAverages([
          { label: 'Prescriptions in the period', value: formattedCount(data?.total) },
          { label: 'Processed → shipped', value: formattedDays(data?.summary?.avgProcessToShipDays) },
          { label: 'Shipped → ETA', value: formattedDays(data?.summary?.avgShipToEtaDays) },
          { label: 'Shipped → delivered', value: formattedDays(data?.summary?.avgShipToDeliveredDays) },
        ]);

        loadingToggle(false);
        firstLoad.current = false;
      } catch (e) {
        console.warn(e);
      }
    })();
  }, [params]);

  return (
    <Card
      title="Per-script detail"
      caption={`Every prescription with its stage timestamps - latest ${limit}`}
      loading={loading}
      firstLoad={firstLoad.current}
    >
      <div className={classes.kv_list}>
        {averages.map((item) => (
          <div className={classes.kv} key={item.label}>
            {item.label}

            <span className={classes.kv_value}>{item.value}</span>
          </div>
        ))}
      </div>
    </Card>
  );
};

ProcessingTimesCard.propTypes = {
  params: PropTypes.object.isRequired,
};

export default ProcessingTimesCard;
